(() => {
  const dialog = document.getElementById("notice-confirm-dialog");
  if (!dialog) return;

  const titleEl = document.getElementById("notice-confirm-title");
  const msgEl = document.getElementById("notice-confirm-text");
  const btnOk = dialog.querySelector("[data-notice-ok]");

  const cfg = window.__productNotice;
  if (!cfg || !cfg.required) return;

  // 商品IDごとに「見た」判定を保存（同一セッション内で1回だけ）
  const productId = cfg.productId;
  const seenKey = productId ? `notice_seen_${productId}` : null;

  if (seenKey && sessionStorage.getItem(seenKey) === "1") return;

  const title = (cfg.title && cfg.title.trim()) ? cfg.title.trim() : "";
  const message = (cfg.message && cfg.message.trim()) ? cfg.message.trim() : "";

  // default空の方針：両方空なら出さない
  if (!title && !message) return;

  if (titleEl) titleEl.textContent = title;
  if (msgEl) msgEl.textContent = message;

  dialog.showModal();

  btnOk?.addEventListener("click", () => {
    if (seenKey) sessionStorage.setItem(seenKey, "1");
    dialog.close(); // 閉じるだけ
  });
})();
